export const GET_PROGRAMS_REQUEST = 'GET_PROGRAMS_REQUEST';
export const GET_PROGRAMS_SUCCESS = 'GET_PROGRAMS_SUCCESS';
export const GET_PROGRAMS_FAIL = 'GET_PROGRAMS_FAIL';
export const UPDATE_ORDER_STATE = 'UPDATE_ORDER_STATE';
export const GET_RESPONSE_STATUS = 'GET_RESPONSE_STATUS';
export const EMPTY_ORDERS = 'EMPTY_ORDERS';
